module.exports = __webpack_public_path__ + "img/collection-engagementRingsBestseller.481c374.jpg";